<template>
  <div>
    <div class="move">

      <b-button
        :disabled="!hasBefore || saving || fetching"
        class="clickable arrows"
        variant="link"
        @click="moveBefore">
        <i class="fas fa-caret-up fa-2x"></i>
      </b-button>

      <b-button
        :disabled="!hasAfter || saving || fetching"
        class="clickable arrows"
        variant="link"
        @click="moveAfter">
        <i class="fas fa-caret-down fa-2x"></i>
      </b-button>

      <b-button
        :disabled="saving || fetching"
        class="clickable"
        variant="link"
        @click="showMoveModal">
        Move
      </b-button>

      <b-button
        :disabled="saving || fetching"
        class="remove clickable"
        variant="link"
        title="remove item"
        @click="showRemoveItem">
        <i class="fas fa-times"></i>
      </b-button>

      <b-modal 
        ref="deleteModalRef"
        centered
        hide-header
        ok-title="Yes, Delete"
        cancel-title="No, Cancel"
        @ok="removeItem">
        {{ deleteMessage }}
      </b-modal>

    </div>
  </div>
</template>

<script>
import moveItem from './move'
import { mapState } from 'vuex'

export default {
  components: {
    moveItem
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data(){
    return {
      showRemoveConfirmation: false,
      deleteMessage: ''
    }
  },
  computed: {
    ...mapState('items', {
      saving: 'saving',
      fetching: 'fetching'
    }),
    hasBefore() {
      return this.$store.getters['items/canMove']({item: this.item, direction: 'up'})
    },
    hasAfter() {
      return this.$store.getters['items/canMove']({item: this.item, direction: 'down'})
    }
  },
  methods: {
    showMoveModal() {
      this.$store.commit('items/showMoveModal', this.item.id)
    },
    moveBefore() {
      this.$store.commit('items/moveByOne', {id: this.item.id, direction: -1})
    },
    moveAfter() {
      this.$store.commit('items/moveByOne', {id: this.item.id, direction: 1})
    },
    showRemoveItem(){
      if (this.item.type === 'row' && this.item.children.length) {
        const n = this.item.children.length
        const plural = (n == 1) ? '' : 's'
        this.deleteMessage = `You are about to delete a row with ${n} item${plural}. Are you sure?`
      }
      else{
        this.deleteMessage =   `Are you sure you want to delete the ${this.item.type}?`
      }
      this.$refs.deleteModalRef.show()
    },
    removeItem(evt) {
      if (this.item.is_saved) {
        this.$store.dispatch('items/destroy', {
          itemID: this.item.id
        })
      } else {
        this.$store.commit('items/removeItem', this.item.id)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/stylesheets/main.scss';

.arrows {
  padding-left: 0;
  padding-right: 0;
}

.move {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -1rem;
}

.remove {
  position: absolute;
  right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/items/options.vue